export function getShortcutKey() {
  const ua = navigator.userAgent;
  if (/Mac/.test(ua)) {
    return "⌘";
  } else {
    return "Ctrl";
  }
}

export function detectChromium() {
  const ua = navigator.userAgent;
  return /Chrome/.test(ua) && !/Edge|Edg|OPR|Brave/.test(ua);
}
